export default __webpack_public_path__ + "static/media/normal-picture.b11b2827.png";